import { render, staticRenderFns } from "./sub-section.vue?vue&type=template&id=8c0ee000&scoped=true&"
import script from "./sub-section.vue?vue&type=script&lang=js&"
export * from "./sub-section.vue?vue&type=script&lang=js&"
import style0 from "./sub-section.vue?vue&type=style&index=0&id=8c0ee000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0ee000",
  null
  
)

export default component.exports